import { styled } from "@linaria/react"
import { useEffect, useRef } from "react"

import { INPUT_HEIGHT_PX, INPUT_PADDING_PX } from "@/components/Input/Input.tsx"
import { inputBaseStyles, inputFocusStyles, inputHoverStyles } from "@/styles/inputMixins.ts"

import type { Property } from "csstype"
import type { RefAttributes, TextareaHTMLAttributes } from "react"


type ResizeableTextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & RefAttributes<HTMLTextAreaElement>

export const ResizeableTextarea = ({ ref, value, ...props }: ResizeableTextareaProps) => {
  const localRef = useRef<HTMLTextAreaElement>(null)
  useEffect(() => {
    if (localRef.current) {
      localRef.current.style.height = "auto"
      localRef.current.style.height = `${localRef.current.scrollHeight}px`
    }
  }, [localRef, value])

  return (
    <textarea ref={(node) => {
      localRef.current = node
      if (typeof ref === "function") {
        ref(node)
      } else if (ref) {
        ref.current = node
      }
    }} value={value} {...props} />
  )
}

export const InputLikeTextarea = styled(ResizeableTextarea)<{
  maxHeight?: Property.MaxHeight
}>`
  min-height: ${INPUT_HEIGHT_PX + INPUT_PADDING_PX * 2}px;
  max-height: ${props => props.maxHeight || "none"};
  padding: ${INPUT_PADDING_PX}px ${INPUT_PADDING_PX}px;
  resize: vertical;

  ${inputBaseStyles};

  &:focus-visible {
    ${inputFocusStyles};
  }

  &:hover:not(:disabled, :focus-visible) {
    ${inputHoverStyles};
  }

  &::placeholder {
    color: var(--secondary-text-color);
  }
`
